<template>
  <LayoutContainer :id="data.cssId" class="dbc-c-mutiteaser">
    <UtilityHeadline
      v-if="data.headlineH2"
      :class="`dbc-text-color-${data.headlineH2Color}`"
      :text="data.headlineH2"
      :level="2"
      :category="{ text: data.categoryH2, color: data.categoryH2Color }"
      :aos="{ fadeDirection: 'fade-right', delay: 300 }"
    />

    <UtilityHeadline
      v-if="data.headlineH4"
      :text="data.headlineH4"
      :level="3"
      :aos="{ fadeDirection: 'fade-right', delay: 300 }"
    />

    <UtilityText
      v-if="data.text"
      :class="`dbc-text-color-${data.textColor} dbc-c-multiteaser__text`"
      :text="data.text"
      :aos="{ fadeDirection: 'fade-right', delay: 300 }"
    />

    <div
      :class="`
        dbc-c-multiteaser__elements
        dbc-c-multiteaser--${data.teaser.length}
        dbc-gt-text-${data.textAlignment}
        `"
    >
      <ContentMultiteaserTeaser
        v-for="(teaser, index) in data.teaser"
        :key="teaser.id"
        :teaser="teaser"
        data-aos="fade"
        data-aos-duration="1200"
        data-aos-offset="100"
        :data-aos-delay="increaseAnimationDelay(index)"
      />
    </div>
  </LayoutContainer>
</template>

<script setup lang="ts">
const props = defineProps<{
  content: ContentMultiteaser
}>()
const data = normalizeMultiteaser(props.content)

function increaseAnimationDelay(index: number) {
  return 300 + 100 * index
}
</script>
